import React from "react";
import { connect } from "react-redux";
import { normalizeMoney, formatDate } from "../utility";
import { Dates, Transaction } from "../constants/enums";
import { reduxForm, change } from "redux-form";
import { generateCreditPayment } from "../businessLogic";
import transactionForm from "./TransactionForm";
import InfoInput from "./InfoInput";
import TransactionTable from "./TransactionTable";
import * as agent from "../agent";
import { MESSAGE_SENDED } from "../constants/actionTypes";
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const prolongationAliases = {"CREDIT": Transaction.OperationProlongationAliases, "DEBIT": Transaction.OperationRepayAliases};
const closeAliases = {"CREDIT": Transaction.OperationCloseAliases, "DEBIT": Transaction.OperationRefundAliases};

const TransactionForm = connect(
    (state, props) => {
        const { operations, credit } = props;
        const { type, sum, side } = credit;
        const closeOperation = operations.find(o => o.alias === (closeAliases[side])[type]) || {};
        const { mustHaveCredit, mustHaveDepartment } = closeOperation;
        return {
            mustHaveCredit,
            mustHaveDepartment,
            initialValues: {
                manager: state.common.user.id,
                paymentDate: formatDate(new Date()),
                operation: closeOperation._id,
                sum: normalizeMoney(sum),
                vat: 0
            },
        };
    }
)(reduxForm({ form: "transaction-form", enableReinitialize: true })(transactionForm));

class closeCredit extends React.Component {

    state = {
        showingModal: false,
        transactions: [],
        managersLoaded: false,
        managers: [],
        counterparties: [],
        counterpartiesLoaded: false,
        accounts: [],
        accountsLoaded: false,
        operations: [],
        operationsLoaded: false,
    };
    fireError = e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } });
    componentWillMount = () => {
        agent.User.managers()
            .then(res => this.setState({ managersLoaded: true, managers: res.managers }))
            .catch(this.fireError);
        agent.Counterparty.getAll()
            .then(res => this.setState({ counterpartiesLoaded: true, counterparties: res }))
            .catch(this.fireError);
        agent.Account.getAll()
            .then(res => this.setState({ accountsLoaded: true, accounts: res }))
            .catch(this.fireError);
        agent.Operation.getAll()
            .then(res => this.setState({ operationsLoaded: true, operations: res }))
            .catch(this.fireError);
    }
    handleClick = (e) => {
        e.preventDefault();
        this.setState({ showingModal: true})
    }
    handleClose = () => this.setState({ showingModal: false})
    addTransaction = (data) => {
        const { operations, transactions } = this.state;
        const { prolongationPayment, dispatch, credit  } = this.props;
        const { type, side, sum } = credit;
        const updTransactions = transactions.concat(data);
        this.setState({ transactions: updTransactions });

        const closeOperation = operations.find(o => o.alias ===  (closeAliases[side])[type]) || {};
        const prolongationOperation = operations.find(o => o.alias === (prolongationAliases[side])[type]) || {};

        const prolongationTSum = updTransactions.reduce((p, n) => p + +(n.operation === prolongationOperation._id ? n.sum.replace(/\s/g,``) : 0), 0);
        const closeTSum = updTransactions.reduce((p, n) => p + +(n.operation === closeOperation._id ? n.sum.replace(/\s/g,``) : 0), 0);

        const closePayed = closeTSum === Math.abs(sum);

        const nextOperation = closePayed ? prolongationOperation._id : closeOperation._id;
        const nextSum = closePayed ? prolongationPayment - prolongationTSum : Math.abs(sum) - closeTSum;

        dispatch(change("transaction-form", "sum", normalizeMoney(Math.max(nextSum, 0))));
        dispatch(change("transaction-form", "operation", nextOperation));
    }

    deleteTransaction = (index) => {
        const { transactions } = this.state;
        this.setState({ transactions: transactions.filter((_, i) => i !== index) })
    }
    onCreditClose = (creditId, data, transactions) => {
        const { updateCredit, dispatch } = this.props;
        agent.Credit.close(creditId, data, transactions)
            .then(res => {
                dispatch({ type: MESSAGE_SENDED, payload: { text: `Займ успешно закрыт`, type: "success" } })
                updateCredit(res);
            })
            .catch(this.fireError);
    }

    render() {
        const { usedDays, prolongationPayment, total, isAdmin, credit, handleSubmit } = this.props;
        const { _id, type, side, sum, duration } = credit;
        const { showingModal,
                transactions,
                managers,
                managersLoaded,
                counterparties,
                counterpartiesLoaded,
                accounts,
                accountsLoaded,
                operations,
                operationsLoaded } = this.state;

        const closeOperation = operations.find(o => o.alias === (closeAliases[side])[type]) || {};
        const prolongationOperation = operations.find(o => o.alias === (prolongationAliases[side])[type]) || {};
        const closeTransactions = transactions.filter(t => t.operation === closeOperation._id);
        const prolongationTransactions = transactions.filter(t => t.operation === prolongationOperation._id);
        const closeTSum = closeTransactions.reduce((p, n) => p + +n.sum.replace(/\s/g,``), 0);
        const prolongationTSum = prolongationTransactions.reduce((p, n) => p + +n.sum.replace(/\s/g,``), 0);

        const allowedOperations = [(closeAliases[side])[type], (prolongationAliases[side])[type]];

        const submitDisabled = Math.abs(sum) === closeTSum && prolongationPayment === prolongationTSum;

        const prepareData = data => Object.assign(data, {
            prolongationPayment,
            usedDays,
        });

        const processTransactions = () => transactions.map(t => {
            const fOperation = operations.find(o => o._id === t.operation) || {};
            return Object.assign(
                {...t},
                {sum: {"DEBIT": 1, "CREDIT": -1}[fOperation.side] * Number(t.sum.replace(/\s/g,``))},
                {alias: fOperation.alias}
            );
        });

        return (
            <Paper className="common-paper" style={{ marginTop: 20, marginBottom: 20 }}>
                <form className="common-column common-form">
                    <InfoInput label="Срок займа"
                               placeholder={duration} />
                    <InfoInput label="Дней пользования"
                               placeholder={usedDays} />
                    <InfoInput label="Сумма займа"
                               endAdornment="₽"
                               placeholder={normalizeMoney(Math.abs(sum))} />
                    <InfoInput label="Проценты"
                               placeholder={normalizeMoney(prolongationPayment)} />
                    <InfoInput label="Итого"
                               endAdornment="₽"
                               placeholder={normalizeMoney(total)} />
                    <Button type="submit"
                            onClick={this.handleClick}
                            style={{ height: 49 }}
                            fullWidth
                            color="primary"
                            size="large"
                            variant="contained">К транзакциям</Button>
                    <Dialog maxWidth={false} open={showingModal} onClose={this.handleClose}>
                        <Paper className="common-paper">
                            <Grid container justify="center" spacing={16}>
                                <Grid item className="common-column">
                                    <TransactionForm allowedOperations={allowedOperations}
                                                     addTransaction={this.addTransaction}
                                                     isAdmin={isAdmin}
                                                     creditMode={true}
                                                     managersLoaded={managersLoaded}
                                                     managers={managers}
                                                     accounts={accounts}
                                                     accountsLoaded={accountsLoaded}
                                                     counterparties={counterparties}
                                                     counterpartiesLoaded={counterpartiesLoaded}
                                                     operations={operations}
                                                     operationsLoaded={operationsLoaded}
                                                     credit={credit} />
                                </Grid>
                                <Grid item className="maxwide-column">
                                    { transactions.length > 0 ?
                                       <TransactionTable transactions={transactions}
                                                         accounts={accounts}
                                                         counterparties={counterparties}
                                                         operations={operations}
                                                         onTransactionDelete={this.deleteTransaction} />
                                       :
                                       <Typography>Добавьте транзакцию</Typography>
                                    }
                                </Grid>
                           </Grid>
                           <Grid container spacing={16}>
                               <Grid item className="common-column">
                                   <Button type="submit"
                                           fullWidth
                                           disabled={!submitDisabled}
                                           onClick={handleSubmit(data => {
                                               this.onCreditClose(_id, prepareData(data), processTransactions(transactions));
                                               this.handleClose();
                                           })}
                                           size="large"
                                           color="primary"
                                           variant="contained" >Займ закрыт</Button>
                               </Grid>
                               <Grid item className="maxwide-column">
                                   {!submitDisabled && <Typography>Для закрытия займа необходимо: </Typography>}
                                   {!submitDisabled && <Typography>1. Провести одну или несколько транзакций закрытия займа на сумму {normalizeMoney(Math.abs(sum))} ₽</Typography>}
                                   {!submitDisabled && prolongationPayment > 0 && <Typography>2. Провести одну или несколько транзакций оплаты процентов на сумму {normalizeMoney(prolongationPayment)} ₽</Typography>}
                                   <Typography>Вы добавили {closeTransactions.length} операций закрытия займа на сумму {normalizeMoney(closeTSum)} ₽</Typography>
                                   {closeTSum > Math.abs(sum) && <Typography style={{ color: "red" }}>Сумма транзакций превышает сумму закрытия займа на {normalizeMoney(closeTSum - Math.abs(sum))} ₽. Удалите одну или несколько транзакций закрытия займа</Typography>}
                                   {closeTSum < Math.abs(sum) && <Typography style={{ color: "red" }}>Cумма закрытия займа превышает сумму транзакций на {normalizeMoney(Math.abs(sum) - closeTSum)} ₽. Добавьте одну или несколько транзакций закрытия займа</Typography>}
                                   {prolongationPayment > 0 && <Typography>Вы добавили {prolongationTransactions.length} операций пролонгации займа на сумму {normalizeMoney(prolongationTSum)} ₽</Typography>}
                                   {prolongationTSum > prolongationPayment && <Typography style={{ color: "red" }}>Сумма транзакций превышает сумму оплаты процентов на {normalizeMoney(prolongationTSum - prolongationPayment)} ₽. Удалите одну или несколько транзакций оплаты процентов</Typography>}
                                   {prolongationTSum < prolongationPayment && <Typography style={{ color: "red" }}>Cумма оплаты процентов превышает сумму транзакций на {normalizeMoney(prolongationPayment - prolongationTSum)} ₽. Добавьте одну или несколько транзакций оплаты процентов</Typography>}
                                   {submitDisabled && <Typography>Cуммы транзакций совпадают. Операция может быть проведена</Typography>}
                                   <Typography>Чтобы изменить суммы операций закройте диалоговое окно</Typography>
                               </Grid>
                           </Grid>
                       </Paper>
                    </Dialog>
                </form>
            </Paper>
        );
    }
}

const CloseCredit = connect(
    (state, props) => {
        const { credit } = props;
        const { sumLog, sum, prolongationDate, date, rate } = credit;

        const pDate = new Date(prolongationDate);
        const lastPaymentDay = new Date();
        const usedDays = Math.floor((lastPaymentDay - pDate) / Dates._1Day);

        const periods = generateCreditPayment({ sumLog, sum, pDate, rate, lastPaymentDay });
        const prolongationPayment = Math.round(periods.reduce((a, b) => a + b.totalSum, 0));

        const total = prolongationPayment + Math.abs(sum);

        return {
            isAdmin: state.common.user.permissions.includes("forms-full-access"),
            total,
            periods,
            usedDays,
            prolongationPayment
        };
    },
    null
)(reduxForm({
    form: "credit-close-form",
    enableReinitialize: true
})(closeCredit));

export default CloseCredit;



// WEBPACK FOOTER //
// ./src/components/CloseCredit.js